import React, { Component } from "react";
import "../../style/common/headerBar.scss";
import Star from "../../icon/Star";
import HalfStar from "../../icon/HalfStar";
import ShoppingCart from "../../icon/ShoppingCart";
import logo from "../../image/logo.png";
import Check from "../../icon/Check";
import header_logo from "../../image/header-logo.png";
import header_logo2 from "../../image/header-logo2.png";
import ShopBasket from "../../icon/ShopBasket";
import { routePage } from "../../utils/routePage";
import Bag from "../../icon/Bag";

class HeaderBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartList: [],
      quantity: 0,
    };
  }
  componentDidMount() {
    if (localStorage.getItem("cart")) {
      let cartList = JSON.parse(localStorage.getItem("cart"));
      let quantity = 0;
      cartList.map((item) => {
        quantity += item.quantity;
      });
      this.setState({ cartList, quantity });
    }
  }

  render() {
    const { quantity } = this.state;
    let { history } = this.props;
    return (
      <React.Fragment>
        <div className="header">
         <div className="contain"> <div className="left">
            <div className="logo" onClick={() => routePage(history, "/")}>
              <img src={logo} alt="" />
            </div>
            <div className="tab">
              <div className="li" onClick={() => routePage(history, "/about")}>
                Our Story
              </div>
              <div className="li" onClick={() => routePage(history, "/privacy")}>
                Privacy Policy
              </div>
              <div className="li" onClick={() => routePage(history, "/ship")}>
              Delivery information
              </div>
              <div className="li" onClick={() => routePage(history, "/Subscribe")}>
                Subscribe
              </div>
            </div>
          </div>
          <div className="shop">
            <ShoppingCart
              size={25}
              className="icon"
              onClick={() => routePage(history, "/cart")}
            />
            <div className="num">{quantity}</div>
          </div></div>
        </div>
      </React.Fragment>
    );
  }
}

export default HeaderBar;
